import { FC } from 'react';
import { Check, X, Loader, TriangleAlert } from 'lucide-react';
import { ActivityItemProps } from '../../types/types';

const ActivityItem: FC<ActivityItemProps> = ({ action, time, status, description }) => {
  const getStatusIcon = () => {
    switch (status.toLowerCase()) {
      case 'success':
        return <Check size={16} className="text-green-600" />;
      case 'warn':
        return <TriangleAlert size={16} className='text-orange-600' />
      case 'error':
      case 'failed':
        return <X size={16} className="text-red-600" />;
      case 'inprogress':
      case 'in progress':
        return <Loader size={16} className="text-yellow-600 animate-spin" />;
      default:
        return <Check size={16} className="text-green-600" />;
    }
  };

  const getStatusClass = () => {
    switch (status.toLowerCase()) {
      case 'success':
        return 'bg-green-100';
      case 'error':
      case 'failed':
        return 'bg-red-100';
      case 'inprogress':
      case 'in progress':
        return 'bg-yellow-100';
      default:
        return 'bg-green-100';
    }
  };

  return (
    <div className="flex items-start p-3 rounded-md hover:bg-gray-50">
      <div className={`mt-0.5 rounded-full p-1 ${getStatusClass()}`}>
        {getStatusIcon()}
      </div>
      <div className="ml-3 flex-1">
        <div className="flex justify-between">
          <p className="text-sm font-medium text-gray-800">{action}</p>
          <p className="text-xs text-gray-500">{time}</p>
        </div>
        <p className="text-sm text-gray-600">{description}</p>
      </div>
    </div>
  );
};

export default ActivityItem;